import { useCallback, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";

import FormFooterEdit from "components/Forms/FooterEdit";
import useTypedContext from "hooks/useTypedContext";
import useBlockNavigationModal from "hooks/useBlockNavigationModal";
import ShareAccountsField from "views/Account/NewModule/Share/AccountsField";
import { useShareModule } from "views/Account/NewModule/ShareNew/useShareModule";
import Card from "ds/components/Card";

import { ModuleSettingsContext } from "../Context";
import { getDefaultValues } from "./utils";

type FormValues = {
  sharedAccounts: Array<{ value: string }>;
  sharedSpaces: Array<{ value: string }>;
};

const ModuleSettingsSharingEditForm = () => {
  const { module } = useTypedContext(ModuleSettingsContext);
  const { shareModule, loading } = useShareModule({
    moduleId: module.id,
  });

  const builderForm = useForm<FormValues>({
    defaultValues: getDefaultValues(module),
    mode: "onChange",
  });

  const {
    handleSubmit,
    formState: { isDirty, isSubmitSuccessful },
    reset,
  } = builderForm;

  useBlockNavigationModal({ isNavigationBlocked: isDirty });

  const onSubmit = useCallback(
    () =>
      handleSubmit((values: FormValues) => {
        return shareModule(values);
      })(),
    [shareModule, handleSubmit]
  );

  useEffect(() => {
    if (isSubmitSuccessful) {
      reset(getDefaultValues(module));
    }
  }, [isSubmitSuccessful, module, reset]);

  return (
    <>
      <FormProvider {...builderForm}>
        <Card variant="secondary" margin="0 0 x-large">
          <ShareAccountsField />
        </Card>
      </FormProvider>
      <FormFooterEdit
        onSubmit={onSubmit}
        onCancel={() => reset(getDefaultValues(module))}
        isDirty={isDirty}
        submitLoading={loading}
        margin="large 0 0"
      />
    </>
  );
};

export default ModuleSettingsSharingEditForm;
